import type { FC } from 'react';
import { resolveImagePath } from '@/utils/imageResolver';

const Footer: FC = () => {
  return (
    <footer className="bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Social Media */}
          <div className="md:col-span-1">
            <div className="mb-6">
              <a href="/">
                <img 
                  src={resolveImagePath('/images/footer-logo.svg')} 
                  alt="Crystal Air Logo | Part 61 Flight Instruction School and Charter Flight Services in Chattanooga, Tennessee"
                  className="h-12 w-auto"
                />
              </a>
            </div>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/flycrystalair/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:opacity-75 transition-opacity"
              >
                <img 
                  src={resolveImagePath('/images/instagram-icon.svg')} 
                  alt="Instagram Icon"
                  className="w-6 h-6"
                />
              </a>
              <a 
                href="https://www.facebook.com/flycrystalair" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:opacity-75 transition-opacity"
              >
                <img 
                  src={resolveImagePath('/images/facebook-icon.svg')} 
                  alt="Facebook Icon"
                  className="w-6 h-6"
                />
              </a>
              <a 
                href="https://www.tiktok.com/@flycrystalair" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:opacity-75 transition-opacity"
              >
                <img 
                  src={resolveImagePath('/images/tiktok-icon.svg')} 
                  alt="TikTok Icon"
                  className="w-6 h-6"
                />
              </a>
            </div>
          </div>

          {/* Contact Us */}
          <div className="md:col-span-1">
            <h5 className="text-gray-900 font-semibold mb-4">Contact Us</h5>
            <div className="space-y-2">
              <a 
                href="tel:4232365100" 
                className="block text-gray-600 hover:text-blue-600 transition-colors"
              >
                423-236-5100
              </a>
              <a 
                href="mailto:info@flycrystalair.com" 
                className="block text-gray-600 hover:text-blue-600 transition-colors"
              >
                info@flycrystalair.com
              </a>
            </div>
          </div>

          {/* Main Office */}
          <div className="md:col-span-1">
            <h5 className="text-gray-900 font-semibold mb-4">Main Office</h5>
            <a 
              href="https://goo.gl/maps/cAPQghbmHFLSqHUA8" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              104 Nowlin Lane Hangar 19<br />
              Chattanooga, TN 37421
            </a>
          </div>

          {/* Quick Links and Legal Info */}
          <div className="md:col-span-1">
            <div className="mb-6">
              <h5 className="text-gray-900 font-semibold mb-4">Quick links</h5>
              <div className="space-y-2">
                <a 
                  href="/about" 
                  className="block text-gray-600 hover:text-blue-600 transition-colors"
                >
                  About Us
                </a>
                <a 
                  href="/locations" 
                  className="block text-gray-600 hover:text-blue-600 transition-colors"
                >
                  Locations
                </a>
                <a 
                  href="https://business.landsend.com/store/flycrystalair/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block text-gray-600 hover:text-blue-600 transition-colors"
                >
                  Crystal Air Wear
                </a>
                <a 
                  href="https://app.flightschedulepro.com/Account/Login?Company=118417" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block text-gray-600 hover:text-blue-600 transition-colors"
                >
                  Flight Schedule Pro
                </a>
              </div>
            </div>

            <div>
              <h5 className="text-gray-900 font-semibold mb-4">Legal info</h5>
              <div className="space-y-2">
                <a 
                  href="/terms-and-conditions" 
                  className="block text-gray-600 hover:text-blue-600 transition-colors"
                >
                  Terms & Conditions
                </a>
                <a 
                  href="/privacy-policy" 
                  className="block text-gray-600 hover:text-blue-600 transition-colors"
                >
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-gray-200 text-center">
          <p className="text-gray-600">© Crystal Air <span>2025</span></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;